import React, { Component } from 'react';

import {  getUser, setLang } from '../Actions/UserActions';
import { slide as Menu } from 'react-burger-menu'

import { connect } from 'react-redux';


import {NavLink} from "react-router-dom";

class NavBar2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            width: window.innerWidth,
            password: '',
            error: '',
            lang: navigator.language || navigator.userLanguage,
            setLang:"en"
        };

        this.setLang=this.setLang.bind(this)
    }
    componentWillMount() {

        if(this.props.lang==="zh"||this.props.lang==="zh-hk"||this.props.lang==="zh-cn"||this.props.lang==="zh-sg"||this.props.lang==="zh-tw"|| this.props.lang==="zh-HK"||this.props.lang==="zh-CN"||this.props.lang==="zh-SG"||this.props.lang==="zh-TW"){
            this.setState({ setLang: "zh"});
        }else{
            this.setState({ setLang: "en"});
        }
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

// make sure to remove the listener
// when the component is not mounted anymore
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }
    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };



setLang(lang){
    this.setState({ setLang: lang});

    this.props.setLang(lang)
}

    renderMenu() {
        var styles = {
            bmBurgerButton: {
                position: 'absolute',
                width: '30px',
                height: '24px',
                left: '10px',
                top: '5px'
            },
            bmBurgerBars: {
                background: 'FireBrick'
            },
            bmCrossButton: {
                height: '24px',
                width: '24px'
            },
            bmCross: {
                background: "FireBrick"
            },
            bmMenu: {
                background: 'white',
                padding: '2.5em 1.5em 0',
                fontSize: '1.15em'
            },
            bmMorphShape: {
                fill: "FireBrick"
            },
            bmItemList: {
                color: 'black',
                padding: '0.8em',
                display: 'block'
            },
            bmItem: {
                display: 'block'
            },
            bmOverlay: {
                background: 'rgba(0, 0, 0, 0.3)'
            }
        }






//
        return(
            <div style={{ padding: 0, width:"100%"}}>




                {this.state.setLang==="en" &&  <div> {this.state.width<500 && <div  style={{margin:"auto", display: "flex"}}>

                    <Menu styles={ styles } >
                        <div> <NavLink activeStyle={{color: "FireBrick"}} to={`/home`}>Home </NavLink></div>

                    </Menu>
                    <div style={{ top: "0", left: "0", width: "15%", height:"100%"}}></div>

                    <div style={{width: "85%", height: "100%", float: "left", padding:"10px",display: "inline-block",verticalAlign: "middle"}}>
                        <NavLink activeStyle={{color: "FireBrick"}} to={`/home`}><img alt="Neat and Fresh" style={{maxHeight:"3.5em", maxWidth: "100%"}}  src="https://firebasestorage.googleapis.com/v0/b/absite-15edf.appspot.com/o/NFC.png?alt=media&token=3051f37d-c98c-4c0b-9a74-bf6c9740fa8b" /></NavLink>
                        </div>
                </div>}






                {this.state.width>=500 && <div className="bb" style={{width:"100%", height: "6vw", padding: 0}}>
                        <div style={{width: "92%", margin: "auto", display: "flex"}}>
                            <div style={{width: "25%", height: "100%", float: "left", padding:"6px",display: "inline-block", verticalAlign: "middle"}}>

                                  <NavLink activeStyle={{color: "FireBrick"}} to={`/home`}><img alt="Neat and Fresh" style={{width: "100%", padding:4,  maxHeight:"100%" }} src="https://firebasestorage.googleapis.com/v0/b/absite-15edf.appspot.com/o/NFC.png?alt=media&token=3051f37d-c98c-4c0b-9a74-bf6c9740fa8b"/></NavLink>


                            </div>
                            <div style={{width: "75%", float: "right" , height: "100%", margin: "auto", display: "flex", fontFamily:"Raleway, sans-serif"}}>
                                <div style={{fontSize: "1.5vw", width: "37%", }} ></div>
                                <div style={{fontSize: "1.5vw", width: "10%", }} className="dropdown"> <span ><NavLink activeStyle={{color: "FireBrick"}} to={`/home`}>Home </NavLink></span>
                                </div>

                            </div>
                        </div>
                    </div>}</div>}








{this.state.setLang==="en" && <div>
                {this.state.width>=500  &&  <div style={{fontSize: "1.2vw", position:"fixed", top:0, right: 0, width: "10%"}} className="dropdown"  ></div>}
                {this.state.width<500  &&  <div style={{fontSize: "4vw", position:"fixed", top:50, left: 0, }} className="dropdown"  ></div>}
</div>}
                {this.state.setLang==="zh" && <div>
                    {this.state.width>=500  &&  <div style={{fontSize: "1.2vw", position:"fixed", top:0, right: 0, width: "10%"}} className="dropdown"  ></div>}
                    {this.state.width<500  &&  <div style={{fontSize: "4vw", position:"fixed", top:60, left: 0, }} className="dropdown"  ></div>}
                </div>}

            </div>




        )
    }





    render() {





        return (

            <div style={{width:"100%"}}>



                {this.renderMenu()}








            </div>


        );
    }
}

function mapStateToProps(state, ownProps) {
    return { user: state.user, admin: state.admin, lang: state.lang };
}

export default connect(mapStateToProps, {  getUser, setLang })(NavBar2);



// WEBPACK FOOTER //
// ./src/Containers/NavBar2.js